<template>
  <div>
    <div style="margin-bottom:30px;">
      <Navigation chosenpage="Vendor Profile" @setDrawer="drawerSet" />
    </div>
    <div v-if="pageStatus === true">
      <div v-if="permission.read_perm === 1">
        <v-card
          style="margin-bottom:30px; position:relative;"
          class="mx-auto"
          height="100%"
          width="99%"
          outlined
        >
          <v-list-item
            three-line
            style=" padding:0 10px; display:flex; flex-direction:row; justify-content:flex-start;align-items:flex-start;"
          >
            <v-col cols="3" style="padding: 10px;">
              <v-img
                height="150"
                aspect-ratio="1.7"
                contain
                cols="12"
                lazy-src
                :src="
                  `${getVendorDetail.urlPath}${getVendorDetail.logo}`
                "
                alt="Company Image: undetected"
              >
              </v-img>

              <div
                class="text-center"
                style="display:flex; flex-direction:row; justify-content:center; align-items:center;"
              >
                <v-rating
                  small
                  readonly
                  :value="
                    getVendorRatting !== null
                      ? Math.round(
                          getVendorRatting[getVendorRatting.length - 1]
                            .avg_rate / 2
                        )
                      : 0
                  "
                  color="yellow darken-3"
                  background-color="grey darken-1"
                  empty-icon="$ratingFull"
                  half-increments
                  hover
                ></v-rating>
                <div style="font-size:12px; position:relative; left:7px;">
                  <v-btn
                    small
                    text
                    icon
                    color="primary"
                    @click="openRatingDialog"
                  >
                  {{
                    getVendorRatting !== null
                      ? (
                          getVendorRatting[getVendorRatting.length - 1]
                            .avg_rate / 2
                        ).toFixed(1)
                      : '0.0'
                  }}
                  </v-btn>
                </div>
              </div>

              <v-list-item-content
                cols="12"
                style="text-align:center; padding:0; margin:0; "
              >
                <v-list-item-subtitle>
                  {{ getVendorDetail.phone1 }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content
                cols="12"
                style="text-align:right; height:20px; padding:0; margin:0; position:relative;"
              >
                <v-list-item-subtitle
                  style="height:25px;"
                >
                  <EditRatting
                    v-bind:items="getVendorDetail.id"
                    :perm="permission"/>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-col>
            <v-col cols="4" style="padding:0;">
              <v-list-item-content style="padding:0; height:200px; ">
                <v-list-item-title
                  class=" title mb-1"
                  style="font-size:12px;padding:0;"
                >
                  {{ getVendorDetail.name.toUpperCase() }}
                  <v-btn
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="loadPage"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </v-list-item-title>
                <v-list-item-title class="overline mb-1">
                  Alamat
                </v-list-item-title>
                <v-list-item-subtitle class=" mb-2">
                  {{ getVendorDetail.address }}
                </v-list-item-subtitle>
                <div>
                  <v-list-item-title class="overline mb-1">
                    Email
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ getVendorDetail.email }}
                  </v-list-item-subtitle>
                </div>
              </v-list-item-content>
            </v-col>

            <v-col cols="4" style="padding:0;">
              <v-list-item-content style="padding:0; height:200px; ">
                <v-col cols="12">
                  <v-list-item-title class="overline mb-1">
                    Klasifikasi
                  </v-list-item-title>
                </v-col>
                <v-col cols="6">
                  <v-list-item-title class="overline mb-1">
                    Bidang
                  </v-list-item-title>
                  <v-list-item-subtitle class=" mb-2">
                    {{
                      getVendorDetail.classification !== null
                        ? getVendorDetail.classification.name
                        : ''
                    }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class=" mb-2">
                    -
                  </v-list-item-subtitle>
                </v-col>

                <v-col cols="6">
                  <v-list-item-title class="overline mb-1">
                    Sub Bidang
                  </v-list-item-title>
                  <v-list-item-subtitle class=" mb-2">
                    {{
                      getVendorDetail.sub_classification !== null
                        ? getVendorDetail.sub_classification.name
                        : '-'
                    }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class=" mb-2">
                    -
                  </v-list-item-subtitle>
                </v-col>
              </v-list-item-content>
            </v-col>

            <v-btn
              style="position: absolute; top: -25px; left: 0;"
              x-small
              text
              outlined
              color="grey darken-2"
                @click="backToVendorList"
            >
              <v-icon small>mdi-arrow-left</v-icon> Kembali
            </v-btn>
            <v-btn
              text
              color="info"
              x-small
              style="position: absolute; bottom: 5px; right:5px;"
              @click="editProfileVendor(false, 'update', getVendorDetail)"
            >
              Lihat Detail <v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
            </v-btn>
            <div
              v-if="getVendorDetail != null"
              class="d-flex justify-center align-center card-title-div2"
              :style="`${statusColor(getVendorDetail.review_status)};`"
            >
              <p class="card-title-div2-name">
                {{ statusName(getVendorDetail.review_status) }}
              </p>
            </div>
          </v-list-item>
        </v-card>

        <v-list>
          <v-card class="mx-auto" width="99%">
            <v-toolbar flat color="warning" dark height="30px">
              <v-card-title
                class="title font-weight-regular justify-space-between"
              >
                <span>{{ headtitle /*getVdrDocumentTab*/ }}</span>
              </v-card-title>
            </v-toolbar>
            <v-tabs vertical>
              <v-tab @click="subFormTitle('INFO KONTAK PIC')"
                >Kontak <br />
              </v-tab>
              <v-tab @click="subFormTitle('INFO PEMBAYARAN')">
                Pembayaran <br />
              </v-tab>
              <v-tab
                @click="subFormTitle('KATEGORI PRODUK / JASA YANG DITAWARKAN')"
              >
                Produk / Jasa
              </v-tab>
              <v-tab @click="subFormTitle('PENGALAMAN', getVendorId)">
                PENGALAMAN <br />
              </v-tab>
              <v-tab @click="subFormTitle('KELENGKAPAN DOKUMEN')">
                Dokumen <br />
              </v-tab>
              <v-tab @click="subFormTitle('KATALOG')">
                KATALOG
              </v-tab>

              <v-tab-item style="padding: 15px;">
                <v-row style="padding: 15px;">
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Nama PIC *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          :readonly="!isEdit"
                          v-model="getVendorDetail.cp_name"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Jabatan / Department
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          v-model="getVendorDetail.cp_position"
                          :items="['Sales / Marketing / Account Manager','Sales Support','Teknik','Manager','Direktur']"
                          style="margin: 0"
                          :outlined="isEdit"
                          :clearable="isEdit"
                          :readonly="!isEdit"
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Nomor Tlp. PIC *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          :readonly="!isEdit"
                          type="number"
                          v-model="getVendorDetail.cp_phone"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Email *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit"
                          :readonly="!isEdit"
                          v-model="getVendorDetail.cp_email"
                        />
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" style="text-align:right;">
                    <v-btn v-if="permission.update_perm == 1 && !isEdit"
                      type="button"
                      color="primary"
                      small
                      @click="isEdit = true"
                    >
                      Edit
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit"
                      @click="saveContact"
                      type="button"
                      color="primary"
                      small
                    >
                      Simpan
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit"
                      type="button"
                      color="error"
                      class='ml-2'
                      small
                      @click="isEdit = false"
                    >
                      Batal
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item style="padding: 15px;">
                <v-row style="padding: 15px;">
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Nama Finance *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit2"
                          :readonly="!isEdit2"
                          v-model="getVendorDetail.finance_name"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Nomor Finance *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit2"
                          :readonly="!isEdit2"
                          type="number"
                          v-model="getVendorDetail.finance_phone"
                        />
                      </v-col>
                    </div>
                  </v-col>

                  <v-col cols="12" md="4">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          No. Rekening *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit2"
                          :readonly="!isEdit2"
                          v-model="getVendorDetail.finance_account_no"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Bank *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          @keydown.enter.prevent
                          v-model="getVendorDetail.finance_bank_name"
                          :items="dropdown.bank"
                          :outlined="isEdit2"
                          :clearable="isEdit2"
                          :readonly="!isEdit2"
                          style="margin: 0"
                          item-text="name"
                          item-value="name"
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          KCU
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit2"
                          :readonly="!isEdit2"
                          v-model="getVendorDetail.finance_bank_kcu"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Atas Nama *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          :outlined="isEdit2"
                          :readonly="!isEdit2"
                          v-model="getVendorDetail.finance_account_name"
                        />
                      </v-col>
                    </div>
                  </v-col>

                  <v-col cols="12" md="8">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Metode Pembayaran *
                        </p>
                      </v-col>
                      <v-col
                        cols="12"
                        style="
                            padding: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-bottom: 0;
                          "
                      >
                        <v-radio-group
                          @keydown.enter.prevent
                          v-model="getVendorDetail.payment_method"
                          :readonly="!isEdit2"
                          style="
                              width: 100%;
                              height: 30px;
                              position: relative;
                              top: -10px;
                            "
                        >
                          <div
                            class="d-flex justify-content-between align-content-between"
                          >
                            <div
                              style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                            >
                              <v-radio
                                :value="1"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">Cash</p>
                            </div>
                            <div
                              style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                            >
                              <v-radio
                                :value="2"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">
                                CBD
                              </p>
                            </div>
                            <div
                              style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                            >
                              <v-radio
                                :value="3"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">
                                TOP
                              </p>
                            </div>
                            <div
                              style="
                                  padding: 0;
                                  justify-content: flex-start;
                                  align-items: center;
                                  display: flex;
                                "
                            >
                              <v-radio
                                :value="4"
                                style="margin: 0; height: 25px; padding: 0"
                              ></v-radio>
                              <p style="margin: 0; font-size: 12px">
                                Lain-lain
                              </p>
                            </div>
                          </div>
                        </v-radio-group>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" style="text-align:right;">
                    <v-btn v-if="permission.update_perm == 1 && !isEdit2"
                      type="button"
                      color="primary"
                      small
                      @click="isEdit2 = true"
                    >
                      Edit
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit2"
                      @click="saveFinance"
                      type="button"
                      color="primary"
                      small
                    >
                      Simpan
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit2"
                      type="button"
                      color="error"
                      class='ml-2'
                      small
                      @click="isEdit2 = false"
                    >
                      Batal
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item style="padding: 15px;">
                <v-row style="padding: 15px;">
                  <v-col cols="12">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Deskripsi produk / jasa yang ditawarkan *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div v-if="isEdit3">
                          <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                          <vue-editor
                            v-model="getVendorDetail.product_description"
                            class="textEditor"
                          ></vue-editor>
                        </div>
                        <div v-else>
                          <div
                            v-if="getVendorDetail.product_description"
                            v-html="getVendorDetail.product_description"
                            style="
                                  padding: 15px;
                                  border: 1px solid rgba(0, 0, 0, 0.1);
                                "
                          ></div>
                          <v-card
                            v-else
                            flat
                            height="30vh"
                            style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                          >
                            <v-toolbar-title class="overline">
                              Data Not Found</v-toolbar-title
                            >
                          </v-card>
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" style="text-align:right;">
                    <v-btn v-if="permission.update_perm == 1 && !isEdit3"
                      type="button"
                      color="primary"
                      small
                      @click="isEdit3 = true"
                    >
                      Edit
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit3"
                      @click="saveProducts"
                      type="button"
                      color="primary"
                      small
                    >
                      Simpan
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit3"
                      type="button"
                      color="error"
                      class='ml-2'
                      small
                      @click="isEdit3 = false"
                    >
                      Batal
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item style="padding: 15px;">
                <v-row style="padding: 15px;">
                  <v-col cols="12">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                        >
                          Jelaskan engalaman anda dalam menyediakan barang /
                          jasa yang sejenis *
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div v-if="isEdit4">
                          <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                          <vue-editor
                            v-model="getVendorDetail.experience"
                            class="textEditor"
                          ></vue-editor>
                        </div>
                        <div v-else>
                          <div
                            v-if="getVendorDetail.experience"
                            v-html="getVendorDetail.experience"
                            style="
                                  padding: 15px;
                                  border: 1px solid rgba(0, 0, 0, 0.1);
                                "
                          ></div>
                          <v-card
                            v-else
                            flat
                            height="30vh"
                            style="
                                  display: flex;
                                  justify-content: center;
                                  align-items: center;
                                "
                          >
                            <v-toolbar-title class="overline">
                              Data Not Found</v-toolbar-title
                            >
                          </v-card>
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" style="text-align:right;">
                    <v-btn v-if="permission.update_perm == 1 && !isEdit4"
                      type="button"
                      color="primary"
                      small
                      @click="isEdit4 = true"
                    >
                      Edit
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit4"
                      @click="saveExperience"
                      type="button"
                      color="primary"
                      small
                    >
                      Simpan
                    </v-btn>
                    <v-btn v-if="permission.update_perm == 1 && isEdit4"
                      type="button"
                      color="error"
                      class='ml-2'
                      small
                      @click="isEdit4 = false"
                    >
                      Batal
                    </v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item style="padding: 15px;">
                <v-row>
                  <v-col cols="12" style="text-align:left;">
                    <v-btn
                      :disabled="permission.update_perm !== 1"
                      color="primary"
                      x-small
                      class="ml-5"
                      @click="documentDialog = true"
                    >
                      <v-icon small>mdi-plus</v-icon> Tambah Dokumen
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row style="padding: 15px;">
                  <v-col cols="12">
                    <v-data-table
                      :headers="documentHeaders"
                      :items="form.vendor_document"
                      @click:row="openDetailDocument"
                      hide-default-footer
                      class="elevation-1"
                      style="cursor: pointer;"
                      dense
                    >
                      <template v-slot:[`item.no`]="{ index }">
                        <div style="width: 35px; font-size: 12px">
                          {{ index + 1 }}
                        </div>
                      </template>
                      <template v-slot:[`item.document_type`]="{ item }">
                        <div class="d-flex justify-start align-center"
                          style="height: 45px; font-size: 12px"
                        >
                          <p style="padding:0; margin:0">{{ item.document_type ? item.document_type.name : null }}</p>
                        </div>
                      </template>
                      <template v-slot:[`item.document_no`]="{ item }">
                        <div class="d-flex justify-start align-center"
                          style="height: 45px; font-size: 12px"
                        >
                          <p style="padding:0; margin:0">{{ item.document_no }}</p>
                        </div>
                      </template>
                      <!-- <template v-slot:[`item.date`]="{ item }">
                        <div class="d-flex justify-start align-center"
                          style="width: 80px; height: 45px; font-size: 12px"
                        >
                          <p style="padding:0; margin:0">{{ item.date }}</p>
                        </div>
                      </template>
                      <template v-slot:[`item.expire_date`]="{ item }">
                        <div class="d-flex justify-start align-center"
                          style="width: 80px; height: 45px; font-size: 12px"
                        >
                          <p style="padding:0; margin:0">{{ item.expire_date }}</p>
                        </div>
                      </template> -->
                      <template v-slot:[`item.file`]="{ item }">
                        <v-tooltip bottom color="grey">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-if="item.file != null"
                                v-bind="attrs"
                                v-on="on"
                                small
                                text
                                icon
                                color="grey darken-2"
                                @click.stop="downloadFile(item)"
                              >
                                <v-icon small>mdi-file-download</v-icon>
                              </v-btn>
                              <v-icon v-bind="attrs" v-on="on" v-else small>mdi-minus</v-icon>
                            </template>
                            <span v-if="item.file != null">Lihat file</span>
                            <span v-else small>File tidak tersedia</span>
                          </v-tooltip>
                      </template>
                      <template v-slot:[`item.description`]="{ item }">
                        <div v-if="item.document_type != null && item.document_type.name == 'OTHER'" class="d-flex justify-start align-center"
                          style="min-width: 170px; height: 25px; font-size: 12px; padding-top:15px;"
                        >
                          <v-autocomplete
                            :value="item.combined_file_type"
                            :items="dropdown.documentType"
                            multiple
                            item-text="name"
                            item-value="id"
                            hide-no-data
                            return-object
                            style="margin: 0; font-size:10px;"
                            small-chips
                            dense
                            flat
                            readonly
                          />
                        </div>
                        <div v-else class="d-flex justify-start align-center"
                          style="width: 160px; height: 45px; font-size: 12px"
                        >
                          <p style="padding:0; margin:0">{{ item.description }}</p>
                        </div>
                      </template>
                      <template v-slot:[`item.action`]="{ item, index }">
                        <div
                          class="d-flex justify-center align-center"
                          style="width: 50px; height: 60px"
                        >
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="primary"
                                class="mr-2"
                                @click.stop="openDetailDocument(item)"
                              >
                                mdi-pencil
                              </v-icon>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="error"
                                @click.stop="clearDocument(item, index)"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item style="padding: 15px;">
                <v-data-table
                  :headers="catalogueHead"
                  :items="getCatalogueList"
                  :items-per-page="itemsPerPage"
                  class="elevation-6 mx-auto"
                  style="width:90%; margin-top: 20px; margin-bottom:20px;"
                  dense
                  hide-default-footer
                >
                  <template v-slot:top>
                    <v-toolbar>
                      <v-icon style="margin-right: 10px;">mdi-cards</v-icon>
                      <v-toolbar-title>Catalogue List</v-toolbar-title>
                      <v-divider class="mx-6" inset vertical></v-divider>
                      <div
                        cols="12"
                        style="padding: 0; justify-content:flex-start; align-items:center; display:flex; margin:5px;"
                      >
                        <p style="margin:0 5px 0 0; color: rgba(0, 0, 0, 0.5);">
                          Investasi
                        </p>
                        <v-checkbox
                          v-model="isAsset"
                          style=" margin:0; height:25px; padding:0;"
                          @change="getAsset"
                        ></v-checkbox>
                      </div>
                      <v-text-field
                        v-model="invokeSrc"
                        label="Search here"
                        type="search"
                        outlined
                        dense
                        style="position: relative; top:15px; width:10px;"
                      ></v-text-field>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.no`]="{ index }">
                    <td>
                      {{ index + 1 * page }}
                    </td>
                  </template>
                  <template v-slot:[`item.currency`]="{ item }">
                    <td>
                      {{ item.currency !== null ? item.currency.code : '-' }}
                    </td>
                  </template>
                  <template v-slot:[`item.merk`]="{ item }">
                    <v-list-item-subtitle>
                      {{ item.merk }}
                    </v-list-item-subtitle>
                  </template>
                  <template v-slot:[`item.last_price`]="{ item }">
                    <td v-if="item.last_price !== null">
                      {{
                        (item.currency !== null ? item.currency.symbol : '') +
                          ' ' +
                          price(item.last_price)
                      }}
                    </td>
                  </template>
                  <template v-slot:[`item.last_ordered`]="{ item }">
                    {{ item.last_ordered | moment('DD/MM/YYYY') }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      color="success"
                      class="ma-1 white--text"
                      small
                      @click.prevent="editCatalogue(['update', item])"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small>
                            {{
                              permission.update_perm !== 1
                                ? 'mdi-file-find'
                                : 'mdi-pencil'
                            }}
                          </v-icon>
                        </template>
                        <span>{{
                          permission.update_perm !== 1 ? 'Detail' : 'Edit'
                        }}</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn
                      color="error"
                      class="ma-1 white--text"
                      small
                      :disabled="
                        permission.update_perm !== 1 ||
                          permission.delete_perm !== 1
                      "
                      @click="deleteCatalogue(item)"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small>
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </v-btn>
                  </template>

                  <template v-slot:footer>
                    <v-toolbar>
                      <v-btn
                        color="#e0e0e0"
                        class="ma-1 black--text"
                        small
                        :disabled="permission.create_perm !== 1"
                        @click.prevent="editCatalogue(['add', null])"
                      >
                        <v-icon left small>
                          mdi-plus
                        </v-icon>
                        Add New Line
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-pagination
                        style="margin-left:auto;"
                        v-model="page"
                        :length="
                          Math.ceil(getTotalCatalogue / itemsPerPage) || 1
                        "
                        :total-visible="6"
                      ></v-pagination>
                      <v-spacer></v-spacer>
                      <div
                        style="padding:0; margin:0;display: flex; flex-direction:rows; justify-content:center; align-items:center;"
                      >
                        <v-toolbar-title class="caption"
                          >Rows per page:</v-toolbar-title
                        >
                        <v-select
                          style="position: relative; margin-left:10px;height:28px; width:50px; right:20px; font-size:12px;"
                          v-model="itemsPerPage"
                          :items="[1, 2, 5, 10, 15, 20, 100]"
                          dense
                        ></v-select>
                      </div>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-list>
        <v-dialog v-model="documentDialog" width="800" persistent>
          <v-form
            :disabled="loading"
            lazy-validation
            ref="documentFormUpload"
            @submit.prevent="saveDocument"
            style="position: relative"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2"> UPLOAD DOKUMEN</v-card-title>

              <v-card-text class="d-flex justify-center align-center">
                <v-row style="padding: 10px" no-gutters>
                  <v-col cols="12" md='4' style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tipe Dokumen
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          v-model="form.document.type"
                          :items="dropdown.documentType"
                          clearable
                          outlined
                          item-text="name"
                          item-value="id"
                          hide-no-data
                          return-object
                          style="margin: 0"
                          dense
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="8" style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Nomor Dokumen
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div>
                          <v-text-field
                            v-model="form.document.no"
                            dense
                            outlined
                          />
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0;" v-if="form.document.type != null && form.document.type.name == 'OTHER'">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Isi Dokumen Meliputi
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          v-model="form.document.combined_file_type"
                          :items="dropdown.documentType"
                          clearable
                          outlined
                          multiple
                          item-text="name"
                          item-value="id"
                          hide-no-data
                          return-object
                          style="margin: 0"
                          small-chips
                          deletable-chips
                          dense
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Keterangan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-textarea
                          v-model="form.document.description"
                          outlined
                          auto-grow
                          rows="2"
                          dense
                        ></v-textarea>
                      </v-col>
                    </div>
                  </v-col>
                  <!-- <v-col cols="12" md="4" style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Terbit
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-model="form.document.date"
                          dense
                          outlined
                          type='date'
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Kadaluarsa
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-model="form.document.expire_date"
                          dense
                          outlined
                          type='date'
                        />
                      </v-col>
                    </div>
                  </v-col> -->
                  <v-col cols="12" md="8" style="padding: 0;">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Upload File
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-file-input
                          ref="uploadDoc"
                          dense
                          :disabled="form.document.type == null"
                          :placeholder="form.document.file != null ? form.document.file : 'Pilih File'"
                          :append-icon="form.document.file != null ? 'mdi-close' : 'mdi-paperclip'"
                          prepend-icon=""
                          outlined
                          clearable
                          @click:append="clearFileDialog"
                          @click:clear="clearFileDialog"
                          @change="(event) => uploadFileDoc(event)"
                        ></v-file-input>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="black darker2"
                  icon
                  outlined
                  type="reset"
                  @click="closeDocumentDialog"
                  :loading="loading"
                  x-small
                  style="position: absolute; top: 10px; right: 10px;"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                  style="width: 100%;"
                >
                  Simpan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>

      <v-card
        flat
        height="75vh"
        v-if="permission.read_perm === 0"
        style="display:flex; justify-content:center; align-items:center;"
      >
        <v-btn
          outlined
          text
          color="error"
          x-small
          style="position: absolute; top: 5px; left:5px;"
          @click="backToVendorList"
        >
          <v-icon>mdi-arrow-left</v-icon> Kembali
        </v-btn>
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>

    <div>
      <VendorDetail @refreshPage="loadPage" :act="vendorDetailAct"/>
    </div>
    <v-navigation-drawer v-model="drawer" fixed height="100vh" temporary>
      <Drawer />
    </v-navigation-drawer>

    <v-card
      v-if="getIsLoading === true"
      class="mx-auto"
      width="99%"
      height="260"
      style="display:flex; justify-content: center; align-items:center; font-size:12px; position:absolute; top:0; height:100%; left:0; right:0;background: rgba(255,255,255,0.5)"
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Please wait</v-progress-circular
      >
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import Navigation from '../../components/navigation/Navigation'
import Drawer from '../../components/navigation/Drawer'
import EditRatting from '../../components/vendor/VendorRate'
import VendorDetail from '../../components/vendor/VendorDetail'
import bankJson from '../../assets/json/bank.json'
import buildType from '../../services/buildType'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'vendorProfile',
  data() {
    return {
      procApi: buildType.apiURL('proc'),
      upload: buildType.apiURL('upload2'),
      drawer: false,
      pageStatus: true,
      path: this.$route.fullPath,
      rating: 1.5,
      page: 1,
      offset: 0,
      itemsPerPage: 5,
      searchCatalogue: '',
      invokeSrc: '',
      headtitle: 'KONTAK PIC',
      step: 1,
      date: new Date().toISOString().substr(0, 10),
      catalogueHead: [
        { text: 'No', sortable: false, value: 'no' },
        { text: 'Product Code', sortable: false, value: 'product_code' },
        {
          text: 'Product Name',
          sortable: false,
          value: 'product_name',
          width: '30%'
        },
        { text: 'Merk', sortable: false, value: 'merk' },
        { text: 'Category', sortable: false, value: 'product_category' },
        { text: 'Currency', sortable: false, value: 'currency' },
        { text: 'Last Price', sortable: false, value: 'last_price' },
        { text: 'Last Ordered', sortable: false, value: 'last_ordered' },
        { text: 'Ordered by', sortable: false, value: 'last_purchase_plant' },
        { text: 'Actions', sortable: false, value: 'actions', align: 'center' }
      ],
      catalogue: [],
      isNewLine: false,
      permission: {},
      menu_key: 17,
      application: {
        id: 2,
        name: 'eProcurement'
      },
      isAsset: false,
      rules: {
        companyNameRules: [],
        companyTypeRules: [],
        addressRules: [],
        provinceRules: [],
        postCodeRules: [],
        latRules: [],
        lngRules: [],
        phoneRules: [],
        emailRules: [],
        companyScaleRules: [],
        classificationRules: [],
        subClassificationRules: [],
        financeRules: [],
        productCategoryRules: [],
        experienceRules: [],
        documentRules: [],
        vendorNameRules: [],
        vendorPhoneRules: [],
        vendorEmailRules: [],
        financeNameRules: [],
        financePhoneRules: [],
        financeAccountNumberRules: [],
        financeBankRules: [],
        financeKcuRules: [],
        financeAccountNameRules: [],
        clientNameRules: [],
        projectDescRules: [],
        projectYearRules: []
      },
      isEdit: false,
      isEdit2: false,
      isEdit3: false,
      isEdit4: false,
      form: {
        vendor_document: [],
        document: {
          act: 'add',
          no: null,
          name: null,
          date: null,
          expire_date: null,
          description: null,
          type: null,
          combined_file_type: []
        }
      },
      dropdown: {
        bank: bankJson,
        documentType: []
      },
      loading: false,
      documentDialog: false,
      vendorDetailAct: 'update'
    }
  },
  components: {
    Navigation,
    EditRatting,
    Drawer,
    VendorDetail
  },
  created() {
    this.setIsLoading(true)
    var arr = this.getUserProfile.level
    for (let i = 0; i < arr.length; i++) {
      if (
        arr[i].application.id === this.application.id ||
        arr[i].application.id === 1
      ) {
        this.menu_access([this.menu_key, this.getUserProfile.level[i].id])
          .then(result => {
            this.permission = result.data
            setTimeout(() => {
              this.loadPage()
              this.setIsLoading(false)
            }, 1500)
          })
          .catch(error => {
            if (error) {
              this.permission = {
                read_perm: 0
              }
              setTimeout(() => {
                this.loadPage()
                this.setIsLoading(false)
              }, 1500)
            }
          })
      } else {
        this.permission = {
          read_perm: 0
        }
        setTimeout(() => {
          this.setIsLoading(false)
        }, 1500)
      }
    }
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getVendorDetail',
      'getVendorUrlParam',
      'getVendorId',
      'getTotalCatalogue',
      'getCatalogueList',
      'getMonth',
      'getIsLoading',
      'getVendorRatting'
      // 'getVendorRouterDetail'
    ]),
    documentHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tipe',
          value: 'document_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'No Dok',
          value: 'document_no',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Tgl. Terbit',
        //   value: 'date',
        //   align: 'left',
        //   sortable: false
        // },
        // {
        //   text: 'Tgl. Expired',
        //   value: 'expire_date',
        //   align: 'left',
        //   sortable: false
        // },
        {
          text: 'File',
          value: 'file',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    }
  },
  watch: {
    invokeSrc() {
      this.searchCatalogue = this.invokeSrc
      this.offset = 0
      this.initCatalogue()
    },
    page() {
      this.offset = this.page - 1
      this.initCatalogue()
    },
    itemsPerPage() {
      this.page = 1
      this.offset = 0
      this.initCatalogue()
    }
  },
  methods: {
    ...mapActions([
      'loadRate',
      'catalogueList',
      'catalogueDelete',
      'detailVendor',
      'businessEntity',
      'currency',
      'province',
      'classification',
      'menu_access'
    ]),
    ...mapMutations([
      'setCatalogueAct',
      'setIsLoading'
    ]),

    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise(resolve => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then(r => {
            resolve(r)
          })
      })
    },
    openDetailDocument(pItem) {
      console.log(pItem)
      this.form.document = {
        act: 'update',
        id: pItem.id,
        no: pItem.document_no,
        description: pItem.description,
        // date: pItem.date,
        // expire_date: pItem.expire_date,
        file: pItem.file,
        type: pItem.document_type,
        combined_file_type: pItem.combined_file_type
      }
      setTimeout(() => {
        this.documentDialog = true
      }, 100)
    },
    async loadDokumenList() {
      await axios
        .get(`${this.procApi}vendor/document/list?offset=0&limit=100&vendor_id=${this.getVendorId}`)
        .then(res => {
          console.log('loadDokumenList', res)
          if (res.data.status_code == '00') {
            this.form.vendor_document = res.data.data
          }
        })
        .catch(err => {
          this.showMsgDialog(
            'error',
            err
              ? 'Dropdown document type error, Please contact an admin!'
              : 'Dropdown document type error, Please contact an admin!',
            false
          )
        })
    },
    closeDocumentDialog() {
      this.documentDialog = false
      setTimeout(() => {
        this.form.document = {
          act: 'add',
          no: null,
          date: null,
          expire_date: null,
          description: null,
          type: null,
          file: null
        }
      }, 100)
    },
    clearEdit() {
      this.isEdit = false
      this.isEdit2 = false
      this.isEdit3 = false
      this.isEdit4 = false
      this.loadPage()
    },
    openRatingDialog() {
      setTimeout(() => {
        document.getElementById('ratingDialog').click()
      }, 200)
    },
    async getDetail() {
      this.setIsLoading(true)
      this.detailVendor(this.getVendorId)
        .then(res => {
          console.log('detailVendor>>>>', res)
          if (res.status_code == '00') {
          } else {
            this.showMsgDialog('error', res.status_msg, false)
          }
          return (this.setIsLoading(false))
        })
        .catch(err => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.setIsLoading(false))
        })
    },
    saveContact() {
      const newForm = {
        act: 'update',
        id: this.getVendorId,
        cp_name: this.getVendorDetail.cp_name,
        cp_email: this.getVendorDetail.cp_email,
        cp_phone: this.getVendorDetail.cp_phone,
        cp_position: this.getVendorDetail.cp_position
      }
      console.log('save contact>>>>', newForm)
      this.saveChange(newForm)
    },
    saveFinance() {
      const newForm = {
        act: 'update',
        id: this.getVendorId,
        finance_account_name: this.getVendorDetail.finance_account_name,
        finance_account_no: this.getVendorDetail.finance_account_no,
        finance_bank_kcu: this.getVendorDetail.finance_bank_kcu,
        finance_bank_name: this.getVendorDetail.finance_bank_name,
        finance_name: this.getVendorDetail.finance_name,
        finance_phone: this.getVendorDetail.finance_phone,
        payment_method: this.getVendorDetail.payment_method
      }
      console.log('save finance>>>>', newForm)
      this.saveChange(newForm)
    },
    saveProducts() {
      const newForm = {
        act: 'update',
        id: this.getVendorId,
        product_description: this.getVendorDetail.product_description
      }
      console.log('save product>>>>', newForm)
      this.saveChange(newForm)
    },
    saveExperience() {
      const newForm = {
        act: 'update',
        id: this.getVendorId,
        experience: this.getVendorDetail.experience
      }
      console.log('save experience>>>>', newForm)
      this.saveChange(newForm)
    },
    async saveChange(form) {
      this.setIsLoading(true)
      await axios
        .post(`${this.procApi}vendor/save`, form)
        .then(res => {
          console.log(res.data)
          this.setIsLoading(false)
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.clearEdit()
        })
        .catch(err => {
          this.clearEdit()
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.setIsLoading(false))
        })
    },
    downloadFile(xItem) {
      console.log('download>>>', xItem)
      window.open(`${xItem.urlPath}${xItem.document_type.name.toLowerCase().split(' ').join('_')}/${xItem.file}`, '_blank')
    },
    async deleteItemDocument(item, index) {
      await axios
        .delete(`${this.procApi}vendor/document/delete/${item.id}`)
        .then(res => {
          console.log('deleteItemDocument', res)
          if (res.data.status_code == '00') {
            this.loadPage()
            this.showMsgDialog('success', res.data.status_msg, false)
          }
        })
        .catch(err => {
          this.showMsgDialog(
            'error',
            err
              ? 'deleteItemDocument error, Please contact an admin!'
              : 'deleteItemDocument error, Please contact an admin!',
            false
          )
        })
    },
    async clearDocument(item, index) {
      console.log(this.form.vendor_document[index].file)
      if (this.form.vendor_document[index].file != null) {
        await this.clearFileUpload(index)
      }
      this.deleteItemDocument(item, index)
    },
    async clearFileUpload(index, method) {
      const fileName = this.form.vendor_document[index].file
      // this.form.vendor_document[index].file = null
      const data = {
        module: this.form.vendor_document[index].document_type.name.toLowerCase().split(' ').join('_'),
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}procurement/vendor/unlink`, data)
        .then(res => {
          console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            if (method == undefined) {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          this.form.vendor_document[index].file = null
          return '-99'
        })
        .catch(err => {
          if (method == undefined) {
            this.showMsgDialog('error', err.message, false)
            this.form.vendor_document[index].file = null
          }
          return '-99'
        })
      return unlink
    },
    async clearFileDialog() {
      const fileName = this.form.document.file
      // this.form.vendor_document[index].file = null
      const data = {
        module: this.form.document.type.name.toLowerCase().split(' ').join('_'),
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}procurement/vendor/unlink`, data)
        .then(res => {
          console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            // this.showMsgDialog('warning', res.data.status_msg, false)
          }
          this.form.document.file = null
          return '-99'
        })
        .catch(err => {
          console.log(err)
          // this.showMsgDialog('error', err.message, false)
          this.form.document.file = null
          return '-99'
        })
      return unlink
    },
    async uploadFileDoc(event) {
      let xFlag = false
      if (this.form.document.file == null) {
        xFlag = true
      } else {
        const xClear = await this.clearFileDialog()
        console.log('xClear:', xClear)
        xFlag = true
      }
      console.log('Event:', event)
      if (xFlag) {
        if (event !== null) {
          if (event.size <= 1024 * 1024 * 3) {
            const data = new FormData()
            data.append('file', event)
            data.append('module', this.form.document.type.name.toLowerCase().split(' ').join('_'))
            // data.append('module', 'vendor')
            axios
              .post(`${this.upload}procurement/vendor`, data)
              .then(res => {
                if (res.data.status === true) {
                  this.showMsgDialog(
                    'success',
                    'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                    false
                  )
                  this.form.document.file = res.data.data.name
                } else {
                  this.showMsgDialog('warning', res.data.message, false)
                }
              })
              .catch(err => {
                this.showMsgDialog('error', err.message, false)
              })
          } else {
            setTimeout(() => {
              this.showMsgDialog('warning', 'Max size = 3MB', false)
            }, 300)
          }
        }
      }
    },
    loadPage() {
      // this.verifyPath()
      this.getDetail()
      this.loadRate(this.getVendorId)
      this.initCatalogue()
      this.getDropdownDocumentType()
      this.loadDokumenList()
    },
    drawerSet(val) {
      this.drawer = val
    },
    editProfileVendor(param1, param2, param3) {
      setTimeout(() => {
        document.getElementById('vendorDetailDialog').click()
      }, 200)
    },
    dropDownInit() {
      this.businessEntity()
      this.currency()
      this.province()
      this.classification()
    },
    subFormTitle(value, paramid) {
      this.headtitle = value
    },
    saveDocument() {
      const newForm = {
        act: this.form.document.act,
        vendor_id: this.getVendorId,
        document_no: this.form.document.no,
        // name: this.form.document.name,
        // date: this.form.document.date,
        // expire_date: this.form.document.expire_date,
        description: this.form.document.description
      }
      if (this.form.document.type != null) {
        Object.assign(newForm, {
          document_type_id: this.form.document.type.id
        })
        if (this.form.document.type.name == 'OTHER') {
          Object.assign(newForm, {
            combined_file_type: this.form.document.combined_file_type
          })
        }
      }
      // if (this.form.document.file != null) {
      Object.assign(newForm, {
        file: this.form.document.file
      })
      // }
      if (this.form.document.act == 'update') {
        Object.assign(newForm, {
          id: this.form.document.id
        })
      }
      console.log('save document>>>>', newForm)
      this.submitDocument(newForm)
    },
    async submitDocument(newForm) {
      this.setIsLoading(true)
      await axios
        .post(`${this.procApi}vendor/document/save`, newForm)
        .then(res => {
          console.log(res.data)
          this.setIsLoading(false)
          if (res.data.status_code == '00') {
            this.loadPage()
            this.showMsgDialog('success', res.data.status_msg, false)
            this.closeDocumentDialog()
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.clearEdit()
        })
        .catch(err => {
          this.clearEdit()
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.setIsLoading(false))
        })
    },

    uploadDoc(event) {
      if (event !== null) {
        this.setIsLoading(true)
        this.vendorDocumentUpload([this.headtitle.toLowerCase(), event])
          .then(result => {
            this.setIsLoading(false)
            if (result.data.status === false) {
              this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: result.data.message,
                showConfirmButton: true,
                showCancelButton: false,
                timer: 4500
              })
            } else if (result.data.status === true) {
              this.$swal.fire({
                position: 'center',
                icon: 'success',
                title: result.data.message,
                showConfirmButton: true,
                showCancelButton: false,
                timer: 4500
              })
              this.formDocument.file = result.data.data.name
            } else {
              this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: result.data.message,
                showConfirmButton: true,
                showCancelButton: false,
                timer: 4500
              })
            }
          })
          .catch(error => {
            this.setIsLoading(false)
            this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: error
                ? 'Somthing went wrong, please contact an admin'
                : 'Somthing went wrong, please contact an admin',
              showConfirmButton: true,
              showCancelButton: false,
              timer: 4500
            })
          })
      } else {
        this.formDocument.file = ''
      }
    },
    backToVendorList() {
      // this.setVendorDetailRouter(null)
      this.$router.push('/master-vendor')
    },
    getAsset(val) {
      this.initCatalogue()
    },
    initCatalogue() {
      this.catalogueList([
        this.getVendorId,
        this.searchCatalogue,
        this.offset * this.itemsPerPage,
        this.itemsPerPage,
        this.isAsset
      ])
        .then(result => {})
        .catch(error => {
          console.log(error)
        })
    },
    editCatalogue(arr) {
      console.log(arr)
      this.setCatalogueAct(arr)
      this.$router.push('/vendor-catalogue')
      // this.$router.push(
      //   `/vendor-catalogue/?${this.getVendorUrlParam.id}=${this.getVendorUrlParam.name}`
      // )
    },
    deleteCatalogue(item) {
      this.$swal
        .fire({
          title: 'Are you sure, this item will be deleted permanently',
          icon: 'warning',
          showCancelButton: true,
          showConfirmButton: true
        })
        .then(result => {
          if (result.value) {
            this.setIsLoading(true)
            this.catalogueDelete(item)
              .then(result => {
                console.log(result)
                this.setIsLoading(false)
                if (result.data.status_code !== '-99') {
                  this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: result.data.status_msg,
                    showConfirmButton: true,
                    timer: 5000
                  })

                  this.initCatalogue()
                } else {
                  this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: result.data.status_msg,
                    showConfirmButton: true,
                    timer: 5000
                  })
                }
              })
              .catch(error => {
                console.log(error)
                this.$swal.fire({
                  position: 'center',
                  icon: 'error',
                  title: error,
                  showConfirmButton: true,
                  timer: 5000
                })
              })
          }
        })
    },

    price(val) {
      const reverse = val
        .toString()
        .split('')
        .reverse()
        .join('')
      var ribuan = reverse.match(/\d{1,3}/g)
      return ribuan
        .join(',')
        .split('')
        .reverse()
        .join('')
    },
    month(val) {
      switch (val) {
        case 1:
          return 'JAN'
        case 2:
          return 'FEB'
        case 3:
          return 'MAR'
        case 4:
          return 'APR'
        case 5:
          return 'MAY'
        case 6:
          return 'JUN'
        case 7:
          return 'JUL'
        case 8:
          return 'AGS'
        case 9:
          return 'SEP'
        case 10:
          return 'OKT'
        case 11:
          return 'NOV'
        case 12:
          return 'DES'
      }
    },
    async getDropdownDocumentType() {
      await axios
        .get(`${this.procApi}master/document_type/drop_down?keyword=`)
        .then(res => {
          console.log('getDropdownDocumentType', res)
          if (res.data.status_code == '00') {
            this.dropdown.documentType = res.data.data
          }
        })
        .catch(err => {
          this.showMsgDialog(
            'error',
            err
              ? 'Dropdown document type error, Please contact an admin!'
              : 'Dropdown document type error, Please contact an admin!',
            false
          )
        })
    },
    statusName(val) {
      switch (val) {
        case 0:
          return 'Need Review'
        case 1:
          return 'Review Complete'
        default:
          return '-'
      }
    },
    statusColor(val) {
      switch (val) {
        case 0:
          return 'color: orange; background-color: #4e4e4e1f;'
        case 1:
          return 'color: green; background-color: #4e4e4e1f;'
        default:
          return 'black'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.card-title-div2 {
  position: absolute;
  right: 0;
  top: 5px;
  padding: 5px 30px;
  min-width: 200px;
  .card-title-div2-name {
    margin: 0;
    font-size: 16px;
    font-weight: bolder;
    text-transform: uppercase;
  }
}
</style>
